/* eslint-disable */
import React, { useEffect } from 'react';
import { AuthContext } from 'components/AuthProvider';
import { Link } from 'gatsby';
import { AuthNav, MarketingNav, UserNav } from 'components/navigation';
import Media from 'react-media';
import homebodyLogo from 'images/homebody-logo-white.png';
import styled from '@emotion/styled';
import { ModalControl } from '@entrata/portals-common/lib/components';
import { Dialog } from 'components/modals';
import { Btn } from 'components/buttons';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logout } from 'redux/modules/user';
import { marketingWebUrl } from 'constants/common';
import { navigate } from 'gatsby';
import { sync, events } from 'api/digitalAnalytics';

const MainHeader = styled('header')`
  height: 64px;
  background-color: ${({ theme }) => theme.secondary.base};
  display: flex;
  justify-content: space-between;
  position: fixed;
  width: 100%;
  z-index: 2;

  @media only screen and (min-width: ${769 / 16}em) {
    background-color: ${({ theme }) => theme.secondary.base};
    display: block;
  }
`;
const LogoLink = styled(Link)`
  width: 200px;
  height: 100%;
  display: inline-flex;
  flex-flow: column;
  justify-content: center;
  opacity: 1;
  padding: ${(p) => (0, p.isMobile ? '16px' : '32px')};

  @media only screen and (max-width: 500px) {
    img {
      width: 130px;
    }
  }
`;
const StyledNav = styled('nav')`
  @media only screen and (min-width: ${769 / 16}em) {
    height: 100%;
    display: inline-block;
    vertical-align: top;
  }

  @media only screen and (max-width: ${768 / 16}em) {
    background: ${({ theme }) => theme.secondary.base};
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    text-align: center;
    transition: all 0.3s ease-out;
    z-index: 1;
  }
`;
const StyledBtn = styled(Btn)`
  padding: 0 32px;
  float: right;
`;
const StyledH2 = styled('h2')`
  font-size: 24px;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.soehneBuch};
  color: ${({ theme }) => theme.secondary.base};
  margin-bottom: 20px;
  @media only screen and (min-width: 767px) {
    margin-bottom: 40px;
  }
`;

const SiteHeader = ({ location, isValidToken, user, getQuote, logout, quoteVersion }) => {
  const handleLogout = () => {
    logout();
    navigate('/');
  };

  useEffect(() => {
    if (!isValidToken) {
      const { TIMEOUT_TRIGGERED } = events;
      const digitalAnalyticsProps = {
        event: { name: TIMEOUT_TRIGGERED },
      };
      sync(digitalAnalyticsProps);
    }
  }, [isValidToken]);

  return (
    <AuthContext.Consumer>
      {({ authenticated }) => {
        return (
          <MainHeader role='banner'>
            <Media query='(min-width: 769px)'>
              {(isDesktop) => {
                return (
                  <React.Fragment>
                    <LogoLink
                      to={authenticated ? '/app/policies/' : marketingWebUrl}
                      title='Homebody'
                      isMobile={!isDesktop}
                    >
                      <img src={homebodyLogo} alt='Homebody' />
                    </LogoLink>
                    {isDesktop && (
                      <StyledNav>
                        {authenticated ? (
                          <AuthNav location={location} />
                        ) : (
                          <MarketingNav location={location} quoteVersion={quoteVersion} />
                        )}
                      </StyledNav>
                    )}
                    <UserNav authenticated={authenticated} location={location} />
                  </React.Fragment>
                );
              }}
            </Media>
            {!isValidToken && (
              <ModalControl>
                {({ show = true, onClick, onClose, ref, ...rest }) => (
                  <Dialog onClose={handleLogout} show={true} {...rest}>
                    <StyledH2>
                      Oops! It looks like your session has expired due inactivity. Please try again or contact our
                      agency for assistance at (866) 249-1066.
                    </StyledH2>
                    <StyledBtn appearance='primary' blockedDisplay={false} onClick={handleLogout}>
                      Close
                    </StyledBtn>
                  </Dialog>
                )}
              </ModalControl>
            )}
          </MainHeader>
        );
      }}
    </AuthContext.Consumer>
  );
};

SiteHeader.propTypes = {
  isValidToken: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
};

export default connect(
  ({ user: { isValidToken, ...user }, getQuote: { ...getQuote } }) => ({
    isValidToken,
    user,
    getQuote,
  }),
  { logout },
)(SiteHeader);
